import instance from '../axios-default';

// Remark: fetchUserTestData only check is existed or not, can differientiate the user can access the feature or not due to the return value is
// 1. test 2. releasedByDistr 3. isRelease
// if not exist, there will be no value.
export const fetchUserTest = async () => {
    try {
        if (!['CN'].includes(process.env.REACT_APP_ENV)) {
            const response = await instance.get(`/userTest`);
            return response.data.result;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error fetching user test data:', error);
        return false;
    }
};

// true if NOT available for upgrade
export const getIsCaseNoCaseTypeUpgrade = async (caseId, planId) => {
    try {
        let res = await instance.get(`case/isCaseNoCaseTypeUpgrade/${caseId}/${planId}`);
        return res.data.result;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};
